import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { I18nConfiguration } from './utils/i18n.config';
import { CommonAppModule } from './features/common/common.module';
import { LoginModule } from './features/login/login.module';

import { SvgInitializer } from './utils/svg.initializer';
import { HttpsRequestInterceptor } from './service/interceptor/interceptor.service';
import { IndexModule } from './features/index/index.module';
import { SharedModule } from './shared.module';
import { CadastroModule } from './features/auto-cadastro/auto-cadastro.module';
import { ProcuracaoModule } from './features/procuracao/procuracao.module';
import { I18nInitializer } from './utils/i18n.initializer';
import { MessagingModule } from '@angular/fire/messaging';
import { DatabaseModule } from '@angular/fire/database'
import { AuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SessionService } from './service/session/session.service';
import { UserService } from './service/user-service/user.service';
import { HomeModule } from './features/home/home.module';
import { CaixaPostalEletronicaModule } from './features/caixa-postal-eletronica/caixa-postal-eletronica.module';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear'
import 'dayjs/locale/pt-br'
import { PerfilUserRoutingModule } from './features/perfil/perfil-user.routing.module';
import { PerfilUserModule } from './features/perfil/perfil-user.module';
import { ProcuracaoRoutingModule } from './features/procuracao/procuracao.routing.module';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { environment } from 'src/environments/environment';
import { HealthcheckComponent } from './features/healthcheck/healthcheck.component';

registerLocaleData(localePt);

/**
 * Factory para carregamento dos arquivos de i18n
 * @param httpClient
 */
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, environment.i18nPath, '.json');
}

export class svgEndpoint {
  getConfig() {
    return { svg_sprites: [`${environment.assetsPath}images/sprite.svg`] };
  }
}

// dayjs.locale('pt-br')

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HealthcheckComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    SharedModule,
    ProcuracaoModule,
    PerfilUserRoutingModule,
    PerfilUserModule,
    CommonAppModule,
    HomeModule,
    LoginModule,
    IndexModule,
    CadastroModule,
    MessagingModule,
    CaixaPostalEletronicaModule,
    DatabaseModule,
    AuthModule,
    RouterModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    HttpClient,
    TranslateService,
    I18nConfiguration,
    UserService,
    svgEndpoint,
    // provide: LOCALE_ID, useValue: 'pt-br'
    {
      provide: APP_INITIALIZER,
      useFactory: SvgInitializer,
      deps: [HttpClient, svgEndpoint],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: I18nInitializer,
      deps: [TranslateService, I18nConfiguration],
      multi: true
    },
  ],
})
export class AppModule { }
